export default __webpack_public_path__ + "static/media/DELETEICON.9d848945.svg";